import { ReactElement, useState } from 'react'

import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Paper from '@mui/material/Paper'

import { CancelIcon, ConfirmIcon } from 'src/v3/core/icons'

interface Props {
  open: string
  setOpen: any
  openText: string
  text: string
  executeAction: () => Promise<unknown>
  confirmText?: string
  title?: string
  onFailure?: (err: any) => void
}

let ConfirmAction = ({
  open,
  setOpen,
  openText,
  executeAction,
  confirmText,
  title,
  text,
  onFailure,
}: Props): ReactElement => {
  let [executing, setExecuting] = useState(false)

  return (
    <Dialog onClose={() => setOpen('')} open={open === openText}>
      <Paper className="px-3 py-1" sx={{ width: 300 }}>
        <DialogTitle sx={{ textAlign: 'center' }}>
          {title || 'Confirm'}
        </DialogTitle>
        <DialogContent className="px-2">{text}</DialogContent>
        <DialogActions className="pb-3 pt-0 flex justify-center">
          {executing ? (
            <CircularProgress className="m-auto" size="36px" />
          ) : (
            <>
              <Button
                onClick={() => {
                  setExecuting(true)
                  executeAction()
                    .then(() => setExecuting(false))
                    .then(() => setOpen(''))
                    .catch((err) => {
                      setOpen('')
                      setExecuting(false)
                      if (onFailure)
                        onFailure(err.data?.response || err.data?.status || err)
                    })
                }}
                color="primary"
                variant="contained"
                sx={{ flex: '1 1 0px' }}
                startIcon={<ConfirmIcon />}
              >
                {confirmText || 'Confirm'}
              </Button>
              <Button
                onClick={() => setOpen('')}
                color="error"
                variant="contained"
                sx={{ flex: '1 1 0px' }}
                startIcon={<CancelIcon />}
              >
                Cancel
              </Button>
            </>
          )}
        </DialogActions>
      </Paper>
    </Dialog>
  )
}

export default ConfirmAction
